/**
 * Niet in het origineel: de eigen keuze op het takenscherm staat ook in de browser, zodat hij
 * na opnieuw laden terugkomt. Per spel, speler en week; zonder opslag (of als die geblokkeerd
 * is) blijft de keuze alleen in het geheugen, zoals eerst.
 */

/** Waar de browser de eigen keuze onthoudt. `round` begint bij 0, de week in de sleutel bij 1. */
export const keuzeSleutel = (spelId: string, spelerId: string, round: number) =>
  `ame-keuze-${spelId}-${spelerId}-week${round + 1}`;

/** De bewaarde keuze; een lege lijst als er niets (bruikbaars) bewaard is. */
export function leesKeuze(sleutel: string): string[] {
  try {
    const waarde: unknown = JSON.parse(localStorage.getItem(sleutel) ?? '[]');
    return Array.isArray(waarde) ? waarde.filter((id) => typeof id === 'string') : [];
  } catch {
    return [];
  }
}

/** Bewaart de keuze; een lege keuze wist de sleutel. */
export function bewaarKeuze(sleutel: string, taken: readonly string[]): void {
  try {
    if (taken.length > 0) localStorage.setItem(sleutel, JSON.stringify(taken));
    else localStorage.removeItem(sleutel);
  } catch {
    // Zonder opslag is de keuze na opnieuw laden weg; dat was altijd zo.
  }
}

/** Wist een bewaarde keuze, zoals die van de vorige week. */
export function vergeetKeuze(sleutel: string): void {
  bewaarKeuze(sleutel, []);
}
